<template>
  <div>
    <section>
      <v-app-bar
        color="#FFFFFF"
        fixed
        nav
        class="box-shadow"
        app
        style="border-radius: 0px; z-index: 9; height: 68px; ">
        <!-- <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/> -->
        
        <v-toolbar-title 
          class="d-flex align-center">


          <!-- <v-chip
            :color="set_color"
            style="min-width: 120px; height: 43px; border-radius: 50px; justify-content: center">
            <span
              class="body-2 white--text mx-2"
              style="font-weight: 600;">
              {{ user.unit_title }}
            </span>
          </v-chip> -->

          <v-img
            src="@/assets/logo/logo_color.png"
            width="182"
            height="32">
          </v-img>
          
        </v-toolbar-title>

        <v-spacer/>
        <div>
          <span class="black_two">Sudah punya akun? </span>
          <span class="blue_one cursor-pointer" @click="toRegister()">Masuk</span>

        </div>

      </v-app-bar>
    </section>
  </div>
</template>


<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {
      toRegister() {
        this.$router.push('/login')
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              console.log(res.results.data)
              let user = res.results.data,
                  menu_arr = res.results.data.category_user_menu_arr.length < 1 ? [] : JSON.parse(res.results.data.category_user_menu_arr)
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_arr.length > 0 ? menu_arr : menu_default)
              )

              TokenService.saveReload(false)

              window.location = `${process.env.BASE_URL}dashboard`
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>
